function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Completed(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm5.312 8.335a1 1 0 00-1.414 0l-5.646 5.647-2.225-2.225a1 1 0 00-1.414 1.414l2.932 2.933a.997.997 0 001.414 0l6.353-6.353a1 1 0 000-1.415z",
    fill: props.color || "#0CAA8F",
    fillRule: "evenodd"
  }));
}
const MemoCompleted = /*#__PURE__*/React.memo(Completed);
export default MemoCompleted;